/**
 * Performance接口列表
 */
 import $http from '../utils/http'// 导入http中创建的axios实例

 const Performance = {
  //RDS PI 数据库平均负载
  sliceby(params){
    return $http.post(`${global.API_URL}/sme/rds/pi/loadavg/sliceby`,params);
  },
  //top list
  toplist(params){
    return $http.post(`${global.API_URL}/sme/rds/pi/loadavg/toplist`,params);
  },
  //top sql
  topSqlMore(params){
    return $http.post(`${global.API_URL}/sme/rds/pi/loadavg/topSqlMore`,params);
  },
 }
 
 export default Performance;

 


// WEBPACK FOOTER //
// ./src/api/performance.js